export const DEEPLINK_DATA_MATCHER = /deeplinkData=([^&]+)/;
export const DEFAULT_REGEX_MATCHER = /([^&]+)/;
//# sourceMappingURL=deeplink.js.map